// ─────────────────────────────────────────────────────────────────────────────
// Selection models
// ─────────────────────────────────────────────────────────────────────────────
// Shared contracts for multi-select surfaces (tables, lists) that support the
// standard keyboard-modifier gestures: plain click, Shift+click (range) and
// Ctrl/Cmd+click (toggle without moving the range anchor).
// ─────────────────────────────────────────────────────────────────────────────

/** Keyboard modifiers active when a selection control was activated. */
export interface SelectionModifiers {
  /** Shift — extend the selection from the anchor to the activated row. */
  shiftKey: boolean;

  /** Ctrl (Windows/Linux) or Cmd (macOS) — toggle a single row, keep the anchor. */
  ctrlKey: boolean;
}

/** Payload emitted by `ui-checkbox` on every state change. */
export interface UiCheckboxChange extends SelectionModifiers {
  /** The checkbox state the user just moved to. */
  checked: boolean;
}

/** A `SelectionModifiers` value with nothing pressed — the plain-click default. */
export const NO_SELECTION_MODIFIERS: SelectionModifiers = { shiftKey: false, ctrlKey: false };
